import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { openWhatsApp } from "@/lib/whatsapp";

export const WhatsAppButton = ({ telefono, text, label = "WhatsApp", testId, size, compact }) => {
  const click = (e) => {
    e.stopPropagation();
    if (!telefono) return toast.error("Il cliente non ha un numero di telefono");
    openWhatsApp(telefono, text);
  };
  return (
    <Button type="button" variant="outline" size={compact ? "icon" : size} onClick={click} data-testid={testId} title="Invia su WhatsApp"
      className="border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:text-emerald-800">
      <MessageCircle className={`h-4 w-4 ${compact ? "" : "mr-1"}`} />{!compact && label}
    </Button>
  );
};
